import * as React from 'react'

import { NotAllowedBlock } from "@components";


export default function buyboxSeller() {
	return {
		name: 'buyboxSeller', label: 'BuyBox Seller',
		options: {
			customBodyRowRender: value => !!value ? value : <NotAllowedBlock />
		}
	}
}